import { KeyValue } from '@/main/models/common';

export enum ApprovalMatrixTypeTypes {
  GET_APPROVAL_MATRIX_TYPE = '@approvalMatrixType/GET_APPROVAL_MATRIX_TYPE',
  SAVE_APPROVAL_MATRIX_TYPE = '@approvalMatrixType/SAVE_APPROVAL_MATRIX_TYPE',
  RESET_REDUCER_APPROVAL_MATRIX_TYPE = '@approvalMatrixType/RESET_REDUCER_APPROVAL_MATRIX_TYPE'
}

export interface ApprovalMatrixTypeState {
  readonly approvalMatrixType: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetApprovalMatrixType {
  type: typeof ApprovalMatrixTypeTypes.GET_APPROVAL_MATRIX_TYPE;
}

export interface SaveApprovalMatrixType {
  type: typeof ApprovalMatrixTypeTypes.SAVE_APPROVAL_MATRIX_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerApprovalMatrixType {
  type: typeof ApprovalMatrixTypeTypes.RESET_REDUCER_APPROVAL_MATRIX_TYPE;
}

export type ApprovalMatrixTypeActionTypes =
  | GetApprovalMatrixType
  | SaveApprovalMatrixType
  | ResetReducerApprovalMatrixType;